'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { type Translator } from '@icebreaker/shared/i18n';

/**
 * ÇEVİRMEN SINIRI — kit kendi çevirmenini KURMAZ, uygulamadan alır.
 *
 * Sözlük `@icebreaker/shared/i18n`dedir (tek kaynak); marka katmanını ve
 * `strict` kipini ÇEVİRMENİ KURAN uygulama belirler (`apps/web`de
 * `shared/i18n/i18n-provider`, ileride admin uygulamasında kendi sağlayıcısı).
 * Böylece kit hiçbir uygulamanın yapılandırmasına bağlanmaz.
 */
const TranslatorContext = createContext<Translator | null>(null);

export function TranslatorProvider({
  translator,
  children,
}: {
  translator: Translator;
  children: ReactNode;
}) {
  return <TranslatorContext.Provider value={translator}>{children}</TranslatorContext.Provider>;
}

/** Bileşenlerde tek metin kaynağı. Koda gömülü metin eslint ile yasaktır. */
export function useTranslation(): Translator {
  const translator = useContext(TranslatorContext);
  if (!translator) {
    throw new Error('useTranslation must be used within I18nProvider');
  }
  return translator;
}
